import { EnabledDisabled } from '@reliance/types/enums/EnabledDisabled';
import { ConnectedDisconnected } from '../enums/ConnectedDisconnected';
export var station = function station(siteApi) {
  return {
    index: function index(params) {
      return siteApi.get('/station', {
        params: params
      }).then(function (stations) {
        stations = stations.map(function (s) {
          var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
          s.stationStatus = {
            status: (_b = (_a = s.stationStatus) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : EnabledDisabled.ENABLED,
            freeswitch: (_d = (_c = s.stationStatus) === null || _c === void 0 ? void 0 : _c.freeswitch) !== null && _d !== void 0 ? _d : ConnectedDisconnected.DISCONNECTED,
            connectServer: (_f = (_e = s.stationStatus) === null || _e === void 0 ? void 0 : _e.connectServer) !== null && _f !== void 0 ? _f : ConnectedDisconnected.DISCONNECTED,
            inCall: (_h = (_g = s.stationStatus) === null || _g === void 0 ? void 0 : _g.inCall) !== null && _h !== void 0 ? _h : false,
            inUse: (_k = (_j = s.stationStatus) === null || _j === void 0 ? void 0 : _j.inUse) !== null && _k !== void 0 ? _k : false
          };
          return s;
        });
        return stations;
      });
    },
    putStatus: function putStatus(id, newStatus) {
      return siteApi.put("/station/status/".concat(id), {
        newStatus: newStatus
      });
    },
    putMultipleStatus: function putMultipleStatus(ids, newStatus) {
      return siteApi.put('/station/multiple/status', {
        ids: ids.join(','),
        newStatus: newStatus
      });
    }
  };
};